//店铺接口
import axios from "../common.js";
import store from "../../store/index";
import { testR } from "../common";

/* axios.defaults.headers = {
  Authorization: `Token token_type=${localStorage.getItem(
    "token_type"
  )}&access_token=${localStorage.getItem("access_token")}`
};
 */
/**
 * 获取店铺会员待审核列表
 * /merchant/v2/membership/account/BindingAuditList
 */
export const bingAuditList = function() {
  var data = {
    merchant_id: localStorage.getItem("merchant_id")
  };
  axios.defaults.headers = {
    Authorization: `Token token_type=${localStorage.getItem(
      "token_type"
    )}&access_token=${localStorage.getItem("access_token")}`
  };
  return new Promise((resolve, reject) => {
    axios
      .post(
        "merchant/v2/membership/account/BindingAuditList",
        JSON.stringify(data)
      )
      .then(res => {
        if (testR(res)) {
          resolve(res.data.resp_data);
        } else {
          reject(false);
        }
      })
      .catch(e => {
        reject(e);
      });
  });
};

/**
 * // /merchant/v2/membership/account/AlterBindingStatus
 * 修改会员绑定状态
 */

export const alterBindingStatus = function(account) {
  var data = {
    merchant_id: localStorage.getItem("merchant_id"),
    account:account
  };
  axios.defaults.headers = {
    Authorization: `Token token_type=${localStorage.getItem(
      "token_type"
    )}&access_token=${localStorage.getItem("access_token")}`
  };
  return axios.post(
    "merchant/v2/membership/account/AlterBindingStatus",
    JSON.stringify(data)
  );
};

/**
 *  配置店铺支付信息
 * /merchant/v2/pay/ConfigurePay
 *  merchant_id店铺id
 * wx_mch_no
 * 微信店铺号
 *
 *
 */
export const payConfigurePay = function({ wx_mch_no }) {
  // const type = localStorage.getItem("token_type")=='merchant';
  var data = {
    merchant_id: localStorage.getItem("merchant_id"),
    wx_mch_no
  };
  axios.defaults.headers = {
    Authorization: `Token token_type=${localStorage.getItem(
      "token_type"
    )}&access_token=${localStorage.getItem("access_token")}`
  };
  return axios.post("/merchant/v2/pay/ConfigurePay", JSON.stringify(data));
};

/**
 *  获取店铺配置支付信息
 * /merchant/v2/pay/GetConfigure
 *  merchant_id店铺id
 * 微信店铺号
 *
 *
 */
export const payGetConfigure = function(
  merchant_id = localStorage.getItem("merchant_id")
) {
  // const type = localStorage.getItem("token_type")=='merchant';
  var data = {
    merchant_id
  };
  axios.defaults.headers = {
    Authorization: `Token token_type=${localStorage.getItem(
      "token_type"
    )}&access_token=${localStorage.getItem("access_token")}`
  };
  return axios.post("/merchant/v2/pay/GetConfigure", JSON.stringify(data));
};
